import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { environment } from '../../environments/environment';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TRANSLOCO_CONFIG, TranslocoModule } from '@ngneat/transloco';
import { httpLoader } from './http-loader';
import { HttpClientModule } from '@angular/common/http';
import { CurrencyPipe } from './pipe';
import { ImageFullscreenComponent } from '../main/product-detail/image-fullscreen/image-fullscreen.component';
import { Ng2ImgMaxModule } from 'ng2-img-max';

@NgModule({
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    Ng2ImgMaxModule,
    CommonModule,
    TranslocoModule,
    HttpClientModule,
    NgxSpinnerModule,
    ModalModule.forRoot(),
  ],
  declarations: [
    CurrencyPipe,
    ImageFullscreenComponent
  ],
  exports: [
    CurrencyPipe,
    NgxSpinnerModule,
    Ng2ImgMaxModule,
    TranslocoModule,
    ImageFullscreenComponent,
    AngularFireModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    ModalModule
  ],
  providers: [
    httpLoader,
    {
      provide: TRANSLOCO_CONFIG,
      useValue: {
        reRenderOnLangChange: true,
        availableLangs: ['vi', 'en'],
        fallbackLang: ['vi', 'en'],
        prodMode: environment.production,
        defaultLang: 'vi'
      }
    }
  ],
})
export class SharedModule { }
